import { Model } from "@vuex-orm/core";
import shortid from "shortid";
import moment from "moment";
import ContactAddress from './Address'
import store from "../store";

export default class Address extends Model {
  static entity = "addresses";
  static fields() {
    return {
      id: this.attr("tmp/" + shortid.generate()),
      originId: this.attr(null),
      companyId: this.attr(null),
      isLocked: this.attr(false),
      name: this.attr(null),
      neighborhood: this.attr(null),
      city: this.attr('MARINGÁ'),
      state: this.attr('PR'),
      cep: this.attr(null),
      dateUpdated: this.attr(null),
      dateCreated: this.attr(moment().toISOString()),
      dateRemoved: this.attr(null),
      status: this.attr('active'),
      addressContactAddresses: this.hasMany(ContactAddress, 'addressId')
    }
  }

  static beforeCreate(model) {
    if(!model.companyId) model.companyId = store.state.auth.user.defaultCompanyId
  }

}
